import dollars from '../../dollar-format';
import {stringISOtoUS} from "../../date-converter";
import {getWeeks} from "../../utils";

export class BucketsColumnsModel {
    AGENT_ID;
    AGENT_LAST_NAME;
    AGENT_FULL_NAME;
    WEEKS;
    START_DATE;
    CALLS;
    AVE_CALLS;
    MEETINGS;
    AVE_MEETINGS;
    PROPOSALS;
    AVE_PROPOSALS;
    TOTAL_LISTINGS;
    TOTAL_UC;
    TOTAL_CLOSED;
    TOTAL_GROSS_FEE;

    constructor(data, year) {
        this.AGENT_ID = data && data.AGENT_ID ? data.AGENT_ID : 0;
        this.AGENT_LAST_NAME = data && data.AGENT_LAST_NAME ? data.AGENT_LAST_NAME : null;
        this.AGENT_FULL_NAME = data && data.AGENT_FIRST_NAME ? data.AGENT_FIRST_NAME : null;
        this.AGENT_FULL_NAME = data && data.AGENT_LAST_NAME ? `${this.AGENT_FULL_NAME} ${data.AGENT_LAST_NAME}` : this.AGENT_FULL_NAME;
        this.START_DATE = data && data.START_DATE ? stringISOtoUS(data.START_DATE) : `01/01/${year}`;
        this.WEEKS = getWeeks(new Date(this.START_DATE), new Date());
        this.CALLS = data && data.CALLS ? parseInt(data.CALLS) : 0;
        this.AVE_CALLS = this.CALLS ? parseFloat(this.CALLS / this.WEEKS).toFixed(2) : 0;
        this.MEETINGS = data && data.MEETINGS ? parseInt(data.MEETINGS) : 0;
        this.AVE_MEETINGS = this.MEETINGS  ? parseFloat(this.MEETINGS / this.WEEKS).toFixed(2) : 0;
        this.PROPOSALS = data && data.TOTAL_PROPOSALS ? parseInt(data.TOTAL_PROPOSALS) : 0;
        this.AVE_PROPOSALS = this.PROPOSALS ? parseFloat(this.PROPOSALS / this.WEEKS).toFixed(2) : 0;
        this.TOTAL_LISTINGS = data && data.TOTAL_LISTINGS ? parseInt(data.TOTAL_LISTINGS) : 0;
        this.TOTAL_UC = data && data.TOTAL_LISTING_UC ? parseInt(data.TOTAL_LISTING_UC) : 0;
        this.TOTAL_UC = data && data.TOTAL_BUYING_UC ? this.TOTAL_UC + parseInt(data.TOTAL_BUYING_UC) : this.TOTAL_UC;
        this.TOTAL_CLOSED = data && data.TOTAL_LISTING_CLOSED ? parseInt(data.TOTAL_LISTING_CLOSED) : 0;
        this.TOTAL_CLOSED = data && data.TOTAL_BUYING_CLOSED ? this.TOTAL_CLOSED + parseInt(data.TOTAL_BUYING_CLOSED) : this.TOTAL_CLOSED;
        this.TOTAL_GROSS_FEE = data && data.LISTING_GROSS_FEE ? parseFloat(data.LISTING_GROSS_FEE) : 0;
        this.TOTAL_GROSS_FEE = data && data.BUYING_GROSS_FEE ? dollars(this.TOTAL_GROSS_FEE + parseFloat(data.BUYING_GROSS_FEE), true) : this.TOTAL_GROSS_FEE;
    }
}